// LivestreamPlayerContext.js
'use strict';
import React from 'react';

export const LivestreamPlayerContext = React.createContext(null);
